import React, { useState, useEffect } from 'react';
import { Collapse, DatePicker, Empty, Form, Space, Tag, Timeline, } from '@bedrock/components';
import { ChevronDown, ChevronUp, Clear } from '@bedrock/icons-react';
import ProcessNode from '../ProcessNode';
import classNames from 'classnames';
import POPOChatIcon from '#features/POPOChatIcon';
import NoResults from "@bedrock/components/es/Empty/images/middle/NoResults";
import dayjs from 'dayjs';
import RenderJournal from "#features/RenderJournal";
import './index.less';
export interface ProgressProps {
  className?: string;
  style?: React.CSSProperties;
  id: number;
  mapNodes: any[];
  remindState: any;
  journals: any;
  journal_type?: string;
  notify_operate_user_list?: any[];
}

const prefixCls = 'demand-status';
const OperationLog = (props: ProgressProps) => {
  const {
    className,
    style,
    id,
    mapNodes,
    remindState,
    journals,
    journal_type,
    notify_operate_user_list,
  } = props;

  const [highlight, setHighlight] = useState(false);
  const [filterJournals, setFilterJournals] = useState([]);
  const [form] = Form.useForm();
  useEffect(() => {
    setFilterJournals([...journals]);
  }, [journals])
  const renderContentTitle = (title: string) => {
    return (
      <div className={`${prefixCls}-content-head`}>
        <div className={`${prefixCls}-icon`}></div>
        <div className={`${prefixCls}-title`}>{title}</div>
      </div>
    );
  };
  const handleFormReset = () => {
    if (!highlight) {
      return;
    }
    const { resetFields } = form;
    resetFields();
    setFilterJournals([...journals]);
    setHighlight(false);
  };

  const handleFormChange = (changeValue, values) => {
    const times = values?.valid_start_date?.map(item => dayjs(item).format('YYYY-MM-DD'));
    const newList = journals?.filter(item => {
      const createdTime = dayjs(dayjs(item.created_at).format('YYYY-MM-DD')).valueOf();
      if (times?.length) {
        if (createdTime >= dayjs(times?.[0]).valueOf() && createdTime <= dayjs(times?.[1]).valueOf()) {
          return item
        }
      } else {
        return item
      }
    })
    if (!times?.length) {
      setHighlight(false)
    } else {
      setHighlight(true)
    }
    setFilterJournals(newList)

  };

  const messageContentRender = (journal: any) => {
    return (
      <React.Fragment>
        <RenderJournal journalList={journal?.details} />
        {!!journal.note && (
          <div className="journal-time-line-detail">
            <div><span className="change-note">备注：</span>{journal.note}</div>
          </div>
        )}
      </React.Fragment>
    );
  };
  const disabledDate = (current) => current && current > dayjs().endOf('day');

  return (
      <div style={style} className={classNames(className,'mpc-progress-container-wrapper')}>
        <Collapse
            bordered={false}
            defaultActiveKey={[0, 1]}
            pure
            arrow="right"
            expandIcon={(panelProps) => {
              return panelProps.isActive ? (
                  <ChevronUp size={24} style={{ color: 'var(--text-color-3)' }} />
              ) : (
                  <ChevronDown size={24} style={{ color: 'var(--text-color-3)' }} />
              );
            }}
        >
          <Collapse.Panel
              id={'header-1'} // 基础信息
              className={'collapseBox'}
              key={0}
              header={renderContentTitle('流程节点')}
              forceRender //设为true时将不会销毁非展开panel的DOM节点
          >
            <div className={'formItemBox'}>
              <Space size={24} direction="vertical">
                <ProcessNode
                    notify_operate_user_list={notify_operate_user_list}
                    journal_type={journal_type}
                    id={id}
                    mapNodes={mapNodes}
                    remindState={remindState}
                />
              </Space>
            </div>
          </Collapse.Panel>
          <Collapse.Panel
              id={'header-2'} // 基础信息
              className={'collapseBox'}
              key={1}
              header={renderContentTitle('更新历史')}
              forceRender //设为true时将不会销毁非展开panel的DOM节点
              style={{ height: 'auto' }}
          >
            <div className={'formItemBox'}>
              <Space size={24} direction="vertical">
                <Form
                    form={form}
                    layout="inline"
                    onValuesChange={handleFormChange}
                >
                  <Space>
                    <Form.Item name={'valid_start_date'}>
                      <DatePicker
                          size="small"
                          range
                          fill
                          disabledDate={disabledDate}
                          placeholder={['更新开始时间', '更新结束时间']}
                      />
                    </Form.Item>
                    <div
                        className={classNames('reset-but', {
                          'reset-but-highlight': highlight,
                        })}
                        onClick={handleFormReset}
                    >
                      <Space size={4}>
                        <Clear /> <span>重置</span>
                      </Space>
                    </div>
                  </Space>
                </Form>
                {(filterJournals && filterJournals?.length > 0) ? (
                    <Timeline className={'timelineBox'}>
                      {
                        filterJournals?.map((jounral, idx) => {
                          const createdTime = dayjs(jounral?.created_at);
                          const email = jounral?.operate_user?.email;
                          const name = jounral?.operate_user?.name;
                          return (
                              <Timeline.Item
                                  key={idx + jounral?.state}
                                  date={<div className="timelineTitle">
                                    {createdTime.format('YYYY-MM-DD')}
                                  </div>}
                                  time={createdTime.format('HH:mm')}
                                  title={
                                    <Space size={8} align="center">
                                      <div className="timelineNodeTitle">
                                        {jounral?.state}
                                      </div>
                                      {!idx && (
                                          <Tag
                                              size="xSmall"
                                              color="light-green"
                                              text="最新"
                                          />
                                      )}
                                    </Space>
                                  }
                                  desc={
                                    <Space size={8} direction='vertical' className="timelineText">
                                      <div>
                                        {`${name || ""} ${(email && email !== "mpc@service.netease.com") ? email : ""}`}{' '}
                                        {email && email !== "mpc@service.netease.com" && <POPOChatIcon ssid={email} />}
                                      </div>
                                      {
                                          jounral?.op_type_name && <Space size={8}>
                                            <span>操作类型:</span>
                                            <span style={{
                                              color: '#1E1D29'
                                            }}>{jounral?.op_type_name}</span>
                                          </Space>
                                      }
                                    </Space>
                                  }
                              >
                                <Space size={2} direction="vertical">
                                  {messageContentRender(jounral)}
                                </Space>
                              </Timeline.Item>
                          )
                        })
                      }</Timeline>
                ) : <Empty
                    className={"empty-box"}
                    style={{ width: '100%' }}
                    imageNode={<NoResults />}
                    text="暂无数据"
                />}
              </Space>
            </div>
          </Collapse.Panel>
        </Collapse>
      </div>
  );
};

export default OperationLog;
